import React, {useState} from 'react';
import {Player} from './types';
import DiscussionTimer from './DiscussionTimer';

interface Props<T> {
    players: Player[];
    data: T;
    joinKey: string;
    excludePlayerId?: string;
    renderCard: (player: Player, data: T) => React.ReactNode;
    renderFullReveal: (data: T) => React.ReactNode;
}

function JoinRound<T>({players, data, joinKey, excludePlayerId, renderCard, renderFullReveal}: Props<T>) {
    const storageKey = `games_join_${joinKey}`;
    const [meId, setMeId] = useState<string | null>(() => localStorage.getItem(storageKey));
    const [showReveal, setShowReveal] = useState(false);

    const me = players.find(p => p.id === meId) || null;

    const pickMe = (player: Player) => {
        try {
            localStorage.setItem(storageKey, player.id);
        } catch {
            // localStorage may be unavailable (private mode, quota) - fail silently
        }
        setMeId(player.id);
    };

    if (!me) {
        const pickable = players.filter(p => p.id !== excludePlayerId);
        const host = excludePlayerId ? players.find(p => p.id === excludePlayerId) : null;
        return (
            <div className="GmCard">
                <h3 className="GmCard-title">Выбери, кто ты</h3>
                {host && (
                    <p className="GmHint">
                        Организатор уже играет за «{host.name}» — эту карточку выбирать не нужно.
                    </p>
                )}
                <div className="GmVoteList">
                    {pickable.map(player => (
                        <button key={player.id} className="GmVoteOption" onClick={() => pickMe(player)}>
                            {player.name}
                        </button>
                    ))}
                </div>
            </div>
        );
    }

    return (
        <div className="GmCard">
            <h3 className="GmCard-title">Ты — {me.name}</h3>
            {renderCard(me, data)}

            <div style={{marginTop: 18}}>
                <DiscussionTimer defaultMinutes={8}/>
            </div>

            <div className="GmBtnRow" style={{marginTop: 16}}>
                <button className="GmBtn" onClick={() => setShowReveal(v => !v)}>
                    {showReveal ? 'Скрыть общий результат' : 'Показать общий результат'}
                </button>
            </div>

            {showReveal && renderFullReveal(data)}
        </div>
    );
}

export default JoinRound;
